import React from 'react';
import { motion } from 'framer-motion';
import { BRAND_MILESTONES } from '../../data/brandData';

export function Timeline() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
          >
            Nuestra Trayectoria
          </motion.h2>
          <div className="w-20 h-1 bg-black mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">
            De 2019 a hoy: cada paso cuenta en nuestra evolución
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid gap-8 md:gap-12">
            {BRAND_MILESTONES.map((milestone, index) => (
              <motion.div
                key={milestone.year}
                initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`flex flex-col md:flex-row gap-6 items-center ${
                  index % 2 === 0 ? '' : 'md:flex-row-reverse'
                }`}
              >
                {/* 年份标签 */}
                <div className="flex-shrink-0 md:w-32">
                  <div className="inline-block md:block px-6 py-3 bg-black text-white font-bold rounded-full text-center">
                    {milestone.year}
                  </div>
                </div>

                {/* 内容卡片 */}
                <div className="flex-1">
                  <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
                    <p className="text-gray-700 leading-relaxed">
                      {milestone.content}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
